export enum AppProductId {
  // Acttive
  SubscriptionM1 = 'monthly_subscription_starting_2021_06_01',
  SubscriptionM3 = 'quarterly_subscription_starting_2021_06_01',
  SubscriptionM6 = '6_month_subscription',
  SubscriptionM12 = 'yearly_subscription_starting_2021_06_01',

  // Archived
  Comsumable2021_08_31 = 'subscription_ending_2021_08_31',
}
